var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "admin-page-content" },
    [
      _c("div", { staticClass: "container-fluid xyz" }, [
        !_vm.isCancelConfirmed
          ? _c("div", { staticClass: "error-detail-main forms-container" }, [
              _c("div", { staticClass: "page-header-top-container" }),
              _vm._v(" "),
              _c("div", { staticClass: "row" }, [
                _c(
                  "div",
                  {
                    staticClass: "col-md-6 form-group",
                    attrs: { id: "customerForm" }
                  },
                  [
                    _c("div", { staticClass: "forms-container" }, [
                      _c("div", { staticClass: "row" }, [
                        _vm._m(0),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "col-md-12 forms-block mt-2" },
                          [
                            _c(
                              "div",
                              {
                                staticClass: "form-label",
                                attrs: { for: "customerName" }
                              },
                              [
                                _vm._v(
                                  "Customer Name : " + _vm._s(_vm.customerName)
                                )
                              ]
                            )
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass: "col-md-6 form-group form-bottom-set"
                          },
                          [
                            _c(
                              "label",
                              {
                                staticClass: "form-label",
                                attrs: { for: "email" }
                              },
                              [_vm._v("First Name")]
                            ),
                            _vm._v(" "),
                            _c("div", { staticClass: "requiredstar" }, [
                              _vm._v("*")
                            ]),
                            _vm._v(" "),
                            _c("input", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: _vm.custFirstName,
                                  expression: "custFirstName"
                                }
                              ],
                              staticClass: "form-control",
                              attrs: {
                                type: "text",
                                id: "custFirstName",
                                placeholder: "First Name",
                                autocomplete: "off"
                              },
                              domProps: { value: _vm.custFirstName },
                              on: {
                                input: function($event) {
                                  if ($event.target.composing) {
                                    return
                                  }
                                  _vm.custFirstName = $event.target.value
                                }
                              }
                            }),
                            _vm._v(" "),
                            _c("font", { staticClass: "text-danger" }, [
                              _vm._v(_vm._s(_vm.custFirstNameError))
                            ])
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass: "col-md-6 form-group form-bottom-set"
                          },
                          [
                            _c(
                              "label",
                              {
                                staticClass: "form-label",
                                attrs: { for: "custLastName" }
                              },
                              [_vm._v("Last Name")]
                            ),
                            _vm._v(" "),
                            _c("div", { staticClass: "requiredstar" }, [
                              _vm._v("*")
                            ]),
                            _vm._v(" "),
                            _c("input", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: _vm.custLastName,
                                  expression: "custLastName"
                                }
                              ],
                              staticClass: "form-control",
                              attrs: {
                                type: "text",
                                id: "custLastName",
                                placeholder: "Last Name",
                                autocomplete: "off"
                              },
                              domProps: { value: _vm.custLastName },
                              on: {
                                input: function($event) {
                                  if ($event.target.composing) {
                                    return
                                  }
                                  _vm.custLastName = $event.target.value
                                }
                              }
                            }),
                            _vm._v(" "),
                            _c("font", { staticClass: "text-danger" }, [
                              _vm._v(_vm._s(_vm.custLastNameError))
                            ])
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass: "col-md-6 form-group form-bottom-set"
                          },
                          [
                            _c(
                              "label",
                              {
                                staticClass: "form-label",
                                attrs: { for: "custcustomerId" }
                              },
                              [_vm._v("Customer")]
                            ),
                            _vm._v(" "),
                            _c("input", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: _vm.custcustomerId,
                                  expression: "custcustomerId"
                                }
                              ],
                              staticClass: "form-control",
                              attrs: {
                                type: "text",
                                id: "custcustomerId",
                                placeholder: "Customer Id",
                                disabled: true
                              },
                              domProps: { value: _vm.custcustomerId },
                              on: {
                                input: function($event) {
                                  if ($event.target.composing) {
                                    return
                                  }
                                  _vm.custcustomerId = $event.target.value
                                }
                              }
                            })
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass: "col-md-6 form-group form-bottom-set"
                          },
                          [
                            _c(
                              "label",
                              {
                                staticClass: "form-label",
                                attrs: { for: "custorderId" }
                              },
                              [_vm._v("Order Number")]
                            ),
                            _vm._v(" "),
                            _c("input", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: _vm.custorderId,
                                  expression: "custorderId"
                                }
                              ],
                              staticClass: "form-control",
                              attrs: {
                                type: "text",
                                id: "custorderId",
                                placeholder: "Order Number",
                                disabled: true
                              },
                              domProps: { value: _vm.custorderId },
                              on: {
                                input: function($event) {
                                  if ($event.target.composing) {
                                    return
                                  }
                                  _vm.custorderId = $event.target.value
                                }
                              }
                            })
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass: "col-md-12 form-group form-bottom-set"
                          },
                          [
                            _c(
                              "label",
                              {
                                staticClass: "form-label",
                                attrs: { for: "custorderAmtDisplay" }
                              },
                              [_vm._v("Order Amount")]
                            ),
                            _vm._v(" "),
                            _c(
                              "sup",
                              {
                                staticStyle: {
                                  color: "#c3202b",
                                  "font-size": "12px"
                                }
                              },
                              [_vm._v("1")]
                            ),
                            _vm._v(" "),
                            _c("input", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: _vm.custorderAmtDisplay,
                                  expression: "custorderAmtDisplay"
                                }
                              ],
                              staticClass: "form-control",
                              staticStyle: { "margin-bottom": "5px" },
                              attrs: {
                                type: "text",
                                id: "custorderAmtDisplay",
                                placeholder: "Order Amount",
                                disabled: true
                              },
                              domProps: { value: _vm.custorderAmtDisplay },
                              on: {
                                input: function($event) {
                                  if ($event.target.composing) {
                                    return
                                  }
                                  _vm.custorderAmtDisplay = $event.target.value
                                }
                              }
                            }),
                            _vm._v(" "),
                            _c("font", { staticClass: "text-order-amount" }, [
                              _c(
                                "sup",
                                {
                                  staticStyle: {
                                    color: "#c3202b",
                                    "font-size": "12px"
                                  }
                                },
                                [_vm._v("1")]
                              ),
                              _vm._v(
                                "TAX AMOUNTS MAY BE ESTIMATED OR MAY NOT BE INCLUDED. CUSTOMER SHALL PAY ALL TAXES ACTUALLY INCURRED AT THE TIME OF SALE."
                              )
                            ])
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass: "col-md-12 form-group form-bottom-set"
                          },
                          [
                            _c(
                              "label",
                              {
                                staticClass: "form-label",
                                attrs: { for: "customerName" }
                              },
                              [
                                _vm._v(
                                  "Billing address on file for the credit card:"
                                )
                              ]
                            ),
                            _vm._v(" "),
                            _c("div", { staticClass: "requiredstar" }, [
                              _vm._v("*")
                            ]),
                            _vm._v(" "),
                            _c("input", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: _vm.address1,
                                  expression: "address1"
                                }
                              ],
                              staticClass: "form-control",
                              attrs: {
                                type: "text",
                                id: "address",
                                placeholder: "Example: 1234 Main Street",
                                autocomplete: "off",
                                maxlength: "30"
                              },
                              domProps: { value: _vm.address1 },
                              on: {
                                input: function($event) {
                                  if ($event.target.composing) {
                                    return
                                  }
                                  _vm.address1 = $event.target.value
                                }
                              }
                            }),
                            _vm._v(" "),
                            _c("font", { staticClass: "text-danger" }, [
                              _vm._v(_vm._s(_vm.address1Error))
                            ])
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass: "col-md-12 form-group form-bottom-set"
                          },
                          [
                            _c(
                              "label",
                              {
                                staticClass: "form-label",
                                attrs: { for: "customerName" }
                              },
                              [_vm._v("Address-2 :")]
                            ),
                            _vm._v(" "),
                            _c("input", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: _vm.address2,
                                  expression: "address2"
                                }
                              ],
                              staticClass: "form-control",
                              attrs: {
                                type: "text",
                                id: "address",
                                placeholder: "Example: Suite 201",
                                autocomplete: "off",
                                maxlength: "30"
                              },
                              domProps: { value: _vm.address2 },
                              on: {
                                input: function($event) {
                                  if ($event.target.composing) {
                                    return
                                  }
                                  _vm.address2 = $event.target.value
                                }
                              }
                            }),
                            _vm._v(" "),
                            _c("font", { staticClass: "text-danger" }, [
                              _vm._v(_vm._s(_vm.address2Error))
                            ])
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass: "col-md-3 form-group form-bottom-set"
                          },
                          [
                            _c(
                              "label",
                              {
                                staticClass: "form-label",
                                attrs: { for: "city" }
                              },
                              [_vm._v("City")]
                            ),
                            _vm._v(" "),
                            _c("div", { staticClass: "requiredstar" }, [
                              _vm._v("*")
                            ]),
                            _vm._v(" "),
                            _c("input", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: _vm.city,
                                  expression: "city"
                                }
                              ],
                              staticClass: "form-control",
                              attrs: {
                                type: "text",
                                id: "city",
                                placeholder: "City",
                                autocomplete: "off"
                              },
                              domProps: { value: _vm.city },
                              on: {
                                input: function($event) {
                                  if ($event.target.composing) {
                                    return
                                  }
                                  _vm.city = $event.target.value
                                }
                              }
                            }),
                            _vm._v(" "),
                            _c("font", { staticClass: "text-danger" }, [
                              _vm._v(_vm._s(_vm.cityError))
                            ])
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass: "col-md-4 form-group form-bottom-set"
                          },
                          [
                            _c(
                              "label",
                              {
                                staticClass: "form-label",
                                attrs: { for: "city" }
                              },
                              [_vm._v("State")]
                            ),
                            _vm._v(" "),
                            _c("div", { staticClass: "requiredstar" }, [
                              _vm._v("*")
                            ]),
                            _vm._v(" "),
                            _c(
                              "v-select",
                              {
                                attrs: {
                                  name: "locationId",
                                  id: "locationId",
                                  label: "Name",
                                  filterable: false,
                                  options: _vm.stateArr,
                                  searchable: true,
                                  placeholder: "Select State"
                                },
                                on: {
                                  change: _vm.changedValue,
                                  input: function($event) {
                                    return _vm.changedValueLocation()
                                  },
                                  search: _vm.onSearchState
                                },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "option",
                                      fn: function(option) {
                                        return [
                                          _c(
                                            "div",
                                            { staticClass: "d-center" },
                                            [
                                              _vm._v(
                                                "\r\n                                          " +
                                                  _vm._s(option.Name) +
                                                  "\r\n                                      "
                                              )
                                            ]
                                          )
                                        ]
                                      }
                                    },
                                    {
                                      key: "selected-option",
                                      fn: function(option) {
                                        return [
                                          _c(
                                            "div",
                                            {
                                              staticClass: "selected d-center"
                                            },
                                            [
                                              _vm._v(
                                                "\r\n                                          " +
                                                  _vm._s(option.Name) +
                                                  "\r\n                                      "
                                              )
                                            ]
                                          )
                                        ]
                                      }
                                    }
                                  ],
                                  null,
                                  false,
                                  4079945636
                                ),
                                model: {
                                  value: _vm.state,
                                  callback: function($$v) {
                                    _vm.state = $$v
                                  },
                                  expression: "state"
                                }
                              },
                              [
                                _c("template", { slot: "no-options" }, [
                                  _vm._v(
                                    "\r\n                                      Search State...\r\n                                  "
                                  )
                                ])
                              ],
                              2
                            ),
                            _vm._v(" "),
                            _c("font", { staticClass: "text-danger" }, [
                              _vm._v(_vm._s(_vm.statusError))
                            ])
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass: "col-md-3 form-group form-bottom-set"
                          },
                          [
                            _c(
                              "label",
                              {
                                staticClass: "form-label",
                                attrs: { for: "zip" }
                              },
                              [_vm._v("Zip")]
                            ),
                            _vm._v(" "),
                            _c("div", { staticClass: "requiredstar" }, [
                              _vm._v("*")
                            ]),
                            _vm._v(" "),
                            _c("input", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: _vm.zip,
                                  expression: "zip"
                                }
                              ],
                              staticClass: "form-control",
                              attrs: {
                                type: "text",
                                id: "zip",
                                placeholder: "Mention zip",
                                minlength: "5"
                              },
                              domProps: { value: _vm.zip },
                              on: {
                                input: function($event) {
                                  if ($event.target.composing) {
                                    return
                                  }
                                  _vm.zip = $event.target.value
                                }
                              }
                            }),
                            _vm._v(" "),
                            _c("font", { staticClass: "text-danger" }, [
                              _vm._v(_vm._s(_vm.zipError))
                            ])
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _vm._m(1),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass: "col-md-6 form-group form-bottom-set"
                          },
                          [
                            _c(
                              "label",
                              {
                                staticClass: "form-label",
                                attrs: { for: "mainPhone" }
                              },
                              [_vm._v("Main Phone")]
                            ),
                            _vm._v(" "),
                            _c("div", { staticClass: "requiredstar" }, [
                              _vm._v("*")
                            ]),
                            _vm._v(" "),
                            _c("input", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: _vm.custmainPhone,
                                  expression: "custmainPhone"
                                }
                              ],
                              staticClass: "form-control",
                              attrs: {
                                id: "mainPhone",
                                placeholder: "Main Phone"
                              },
                              domProps: { value: _vm.custmainPhone },
                              on: {
                                input: function($event) {
                                  if ($event.target.composing) {
                                    return
                                  }
                                  _vm.custmainPhone = $event.target.value
                                }
                              }
                            }),
                            _vm._v(" "),
                            _c("font", { staticClass: "text-danger" }, [
                              _vm._v(_vm._s(_vm.custmainPhoneError))
                            ])
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass: "col-md-6 form-group form-bottom-set"
                          },
                          [
                            _c(
                              "label",
                              {
                                staticClass: "form-label",
                                attrs: { for: "custOtherPhone" }
                              },
                              [_vm._v("Other Phone")]
                            ),
                            _vm._v(" "),
                            _c("input", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: _vm.custOtherPhone,
                                  expression: "custOtherPhone"
                                }
                              ],
                              staticClass: "form-control",
                              attrs: {
                                type: "text",
                                id: "custOtherPhone",
                                placeholder: "Other Phone"
                              },
                              domProps: { value: _vm.custOtherPhone },
                              on: {
                                input: function($event) {
                                  if ($event.target.composing) {
                                    return
                                  }
                                  _vm.custOtherPhone = $event.target.value
                                }
                              }
                            })
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass: "col-md-6 form-group form-bottom-set"
                          },
                          [
                            _c(
                              "label",
                              {
                                staticClass: "form-label",
                                attrs: { for: "email" }
                              },
                              [_vm._v("Email")]
                            ),
                            _vm._v(" "),
                            _c("div", { staticClass: "requiredstar" }, [
                              _vm._v("*")
                            ]),
                            _vm._v(" "),
                            _c("input", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: _vm.custEmail,
                                  expression: "custEmail"
                                }
                              ],
                              staticClass: "form-control",
                              attrs: {
                                type: "text",
                                id: "email",
                                placeholder: "example123@example.com"
                              },
                              domProps: { value: _vm.custEmail },
                              on: {
                                input: function($event) {
                                  if ($event.target.composing) {
                                    return
                                  }
                                  _vm.custEmail = $event.target.value
                                }
                              }
                            }),
                            _vm._v(" "),
                            _c("font", { staticClass: "text-danger" }, [
                              _vm._v(_vm._s(_vm.custEmailError))
                            ])
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass: "col-md-6 form-group form-bottom-set"
                          },
                          [
                            _c(
                              "label",
                              {
                                staticClass: "form-label",
                                attrs: { for: "email" }
                              },
                              [_vm._v("Email 2")]
                            ),
                            _vm._v(" "),
                            _c("input", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: _vm.custEmail2,
                                  expression: "custEmail2"
                                }
                              ],
                              staticClass: "form-control",
                              attrs: {
                                type: "text",
                                id: "email2",
                                placeholder: "example123@example.com"
                              },
                              domProps: { value: _vm.custEmail2 },
                              on: {
                                input: function($event) {
                                  if ($event.target.composing) {
                                    return
                                  }
                                  _vm.custEmail2 = $event.target.value
                                }
                              }
                            }),
                            _vm._v(" "),
                            _c("font", { staticClass: "text-danger" }, [
                              _vm._v(_vm._s(_vm.custEmail2Error))
                            ])
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass: "col-md-12 form-group form-bottom-set"
                          },
                          [
                            _c(
                              "label",
                              {
                                staticClass: "form-label",
                                attrs: { for: "email" }
                              },
                              [_vm._v("Email 3")]
                            ),
                            _vm._v(" "),
                            _c("input", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: _vm.custEmail3,
                                  expression: "custEmail3"
                                }
                              ],
                              staticClass: "form-control",
                              attrs: {
                                type: "text",
                                id: "email3",
                                placeholder: "example123@example.com"
                              },
                              domProps: { value: _vm.custEmail3 },
                              on: {
                                input: function($event) {
                                  if ($event.target.composing) {
                                    return
                                  }
                                  _vm.custEmail3 = $event.target.value
                                }
                              }
                            }),
                            _vm._v(" "),
                            _c("font", { staticClass: "text-danger" }, [
                              _vm._v(_vm._s(_vm.custEmail3Error))
                            ])
                          ],
                          1
                        )
                      ])
                    ])
                  ]
                ),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass: "col-md-6 form-group",
                    attrs: { id: "customerForm" }
                  },
                  [
                    _c(
                      "div",
                      {
                        staticClass: "forms-container",
                        staticStyle: { height: "100%" }
                      },
                      [
                        _c(
                          "div",
                          { staticClass: "row" },
                          [
                            _vm._m(2),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                staticClass:
                                  "col-md-12 form-group mt-2 form-bottom-set"
                              },
                              [
                                _c(
                                  "div",
                                  { staticStyle: { "line-height": "2" } },
                                  [
                                    _vm._v(
                                      "\r\n                              I, "
                                    ),
                                    _c("input", {
                                      directives: [
                                        {
                                          name: "model",
                                          rawName: "v-model",
                                          value: _vm.fullName,
                                          expression: "fullName"
                                        }
                                      ],
                                      staticClass:
                                        "col-11 form-control d-inline-block",
                                      attrs: {
                                        type: "text",
                                        id: "custFirstName",
                                        placeholder:
                                          "Full Name as it appears on the Credit Card",
                                        maxlength: "30"
                                      },
                                      domProps: { value: _vm.fullName },
                                      on: {
                                        input: function($event) {
                                          if ($event.target.composing) {
                                            return
                                          }
                                          _vm.fullName = $event.target.value
                                        }
                                      }
                                    }),
                                    _vm._v(
                                      " authorize Velocity Vehicle Group (and their affiliates) to charge my credit card.\r\n                              "
                                    )
                                  ]
                                ),
                                _vm._v(" "),
                                _c("font", { staticClass: "text-danger" }, [
                                  _vm._v(_vm._s(_vm.acknowladgementError))
                                ])
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                staticClass:
                                  "col-md-12 form-group form-bottom-set"
                              },
                              [
                                _c(
                                  "label",
                                  {
                                    staticClass: "form-label",
                                    attrs: { for: "email" }
                                  },
                                  [_vm._v("Card Number")]
                                ),
                                _vm._v(" "),
                                _c("div", { staticClass: "requiredstar" }, [
                                  _vm._v("*")
                                ]),
                                _vm._v(" "),
                                _c("div", { staticClass: "input-group mb-0" }, [
                                  _c(
                                    "div",
                                    { staticClass: "input-group-prepend" },
                                    [
                                      _c(
                                        "span",
                                        { staticClass: "input-group-text" },
                                        [
                                          _c("img", {
                                            attrs: {
                                              src: _vm.cardBrandClass,
                                              alt: "card"
                                            }
                                          })
                                        ]
                                      )
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c("input", {
                                    directives: [
                                      {
                                        name: "model",
                                        rawName: "v-model",
                                        value: _vm.cardNumber,
                                        expression: "cardNumber"
                                      },
                                      {
                                        name: "cardformat",
                                        rawName:
                                          "v-cardformat:formatCardNumber",
                                        arg: "formatCardNumber"
                                      }
                                    ],
                                    ref: "cardNumInput",
                                    staticClass: "form-control",
                                    attrs: {
                                      placeholder: "#### #### #### ####"
                                    },
                                    domProps: { value: _vm.cardNumber },
                                    on: {
                                      input: function($event) {
                                        if ($event.target.composing) {
                                          return
                                        }
                                        _vm.cardNumber = $event.target.value
                                      }
                                    }
                                  })
                                ]),
                                _vm._v(" "),
                                _c("font", { staticClass: "text-danger" }, [
                                  _vm._v(_vm._s(_vm.cardNumberError))
                                ])
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                staticClass:
                                  "col-md-4 form-group form-bottom-set"
                              },
                              [
                                _c(
                                  "label",
                                  {
                                    staticClass: "form-label",
                                    attrs: { for: "email" }
                                  },
                                  [_vm._v("Expiry Month")]
                                ),
                                _vm._v(" "),
                                _c("div", { staticClass: "requiredstar" }, [
                                  _vm._v("*")
                                ]),
                                _vm._v(" "),
                                _c("multiselect", {
                                  attrs: {
                                    name: "listActivity",
                                    id: "listActivity",
                                    label: "month",
                                    options: _vm.expMonthList,
                                    multiple: false,
                                    "track-by": "month",
                                    hideSelected: false,
                                    selectLabel: "",
                                    deselectLabel: "",
                                    selectedLabel: "",
                                    placeholder: "Select Expiry Month"
                                  },
                                  model: {
                                    value: _vm.expMonth,
                                    callback: function($$v) {
                                      _vm.expMonth = $$v
                                    },
                                    expression: "expMonth"
                                  }
                                }),
                                _vm._v(" "),
                                _c("font", { staticClass: "text-danger" }, [
                                  _vm._v(_vm._s(_vm.expMonthError))
                                ])
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                staticClass:
                                  "col-md-4 form-group form-bottom-set"
                              },
                              [
                                _c(
                                  "label",
                                  {
                                    staticClass: "form-label",
                                    attrs: { for: "email" }
                                  },
                                  [_vm._v("Expiry Year")]
                                ),
                                _vm._v(" "),
                                _c("div", { staticClass: "requiredstar" }, [
                                  _vm._v("*")
                                ]),
                                _vm._v(" "),
                                _c("multiselect", {
                                  attrs: {
                                    name: "listYear",
                                    id: "listYear",
                                    label: "year",
                                    options: _vm.expYearList,
                                    multiple: false,
                                    "track-by": "year",
                                    taggable: true,
                                    hideSelected: false,
                                    selectLabel: "",
                                    deselectLabel: "",
                                    selectedLabel: "",
                                    placeholder: "Select Expiry Year"
                                  },
                                  on: { tag: _vm.addYear },
                                  model: {
                                    value: _vm.expYear,
                                    callback: function($$v) {
                                      _vm.expYear = $$v
                                    },
                                    expression: "expYear"
                                  }
                                }),
                                _vm._v(" "),
                                _c("font", { staticClass: "text-danger" }, [
                                  _vm._v(_vm._s(_vm.expYearError))
                                ])
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                staticClass:
                                  "col-md-4 form-group form-bottom-set"
                              },
                              [
                                _c(
                                  "label",
                                  {
                                    staticClass: "form-label",
                                    attrs: {
                                      id: "cvvId",
                                      "data-toggle": "tooltip"
                                    }
                                  },
                                  [_vm._v("CVV")]
                                ),
                                _vm._v(" "),
                                _c("div", { staticClass: "requiredstar" }, [
                                  _vm._v("*")
                                ]),
                                _vm._v(" "),
                                _c("i", {
                                  staticClass: "fa fa-question-circle"
                                }),
                                _vm._v(" "),
                                _c("b-tooltip", {
                                  attrs: {
                                    target: "cvvId",
                                    title:
                                      "3 digits code on back side of the card",
                                    placement: "top"
                                  }
                                }),
                                _vm._v(" "),
                                _c("input", {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value: _vm.cvv,
                                      expression: "cvv"
                                    },
                                    {
                                      name: "cardformat",
                                      rawName: "v-cardformat:formatCardCVC",
                                      arg: "formatCardCVC"
                                    }
                                  ],
                                  staticClass: "form-control",
                                  attrs: { required: "", type: "password" },
                                  domProps: { value: _vm.cvv },
                                  on: {
                                    input: function($event) {
                                      if ($event.target.composing) {
                                        return
                                      }
                                      _vm.cvv = $event.target.value
                                    }
                                  }
                                }),
                                _vm._v(" "),
                                _c("font", { staticClass: "text-danger" }, [
                                  _vm._v(_vm._s(_vm.cvvError))
                                ])
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _vm.showCheckBox
                              ? _c(
                                  "div",
                                  {
                                    staticClass:
                                      "col-md-12 form-check form-group form-bottom-set",
                                    staticStyle: { "padding-left": "3rem" }
                                  },
                                  [
                                    _c(
                                      "label",
                                      {
                                        staticClass:
                                          "checkbox-bootstrap checkbox-lg form-label d-block"
                                      },
                                      [
                                        _c("input", {
                                          directives: [
                                            {
                                              name: "model",
                                              rawName: "v-model",
                                              value: _vm.keepCardOnFile,
                                              expression: "keepCardOnFile"
                                            }
                                          ],
                                          attrs: { type: "checkbox" },
                                          domProps: {
                                            checked: Array.isArray(
                                              _vm.keepCardOnFile
                                            )
                                              ? _vm._i(
                                                  _vm.keepCardOnFile,
                                                  null
                                                ) > -1
                                              : _vm.keepCardOnFile
                                          },
                                          on: {
                                            change: function($event) {
                                              var $$a = _vm.keepCardOnFile,
                                                $$el = $event.target,
                                                $$c = $$el.checked
                                                  ? true
                                                  : false
                                              if (Array.isArray($$a)) {
                                                var $$v = null,
                                                  $$i = _vm._i($$a, $$v)
                                                if ($$el.checked) {
                                                  $$i < 0 &&
                                                    (_vm.keepCardOnFile = $$a.concat(
                                                      [$$v]
                                                    ))
                                                } else {
                                                  $$i > -1 &&
                                                    (_vm.keepCardOnFile = $$a
                                                      .slice(0, $$i)
                                                      .concat(
                                                        $$a.slice($$i + 1)
                                                      ))
                                                }
                                              } else {
                                                _vm.keepCardOnFile = $$c
                                              }
                                            }
                                          }
                                        }),
                                        _vm._v(" "),
                                        _c("span", {
                                          staticClass: "checkbox-placeholder"
                                        }),
                                        _vm._v(
                                          "\r\n                                Keep Card on File\r\n                            "
                                        )
                                      ]
                                    )
                                  ]
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.showCheckBox
                              ? _c(
                                  "font",
                                  {
                                    staticClass: "text-danger",
                                    staticStyle: { "padding-left": "1rem" }
                                  },
                                  [_vm._v(_vm._s(_vm.keepCardText))]
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                staticClass:
                                  "col-md-12 form-group form-bottom-set"
                              },
                              [
                                _c(
                                  "div",
                                  {
                                    staticClass: "form-label",
                                    staticStyle: { padding: "3px 1px 7px" },
                                    attrs: { for: "customerName" }
                                  },
                                  [_vm._v("Notes")]
                                ),
                                _vm._v(" "),
                                _c("textarea", {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value: _vm.note,
                                      expression: "note"
                                    }
                                  ],
                                  staticClass: "form-control",
                                  attrs: { type: "text", id: "note" },
                                  domProps: { value: _vm.note },
                                  on: {
                                    input: function($event) {
                                      if ($event.target.composing) {
                                        return
                                      }
                                      _vm.note = $event.target.value
                                    }
                                  }
                                })
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                staticClass:
                                  "col-md-12 form-group form-bottom-set"
                              },
                              [
                                _c(
                                  "div",
                                  {
                                    staticStyle: {
                                      padding: "1rem 1rem 1rem 2.9rem",
                                      background:
                                        "#DBEFFC 0% 0% no-repeat padding-box",
                                      opacity: "1",
                                      "border-radius": "3px"
                                    }
                                  },
                                  [
                                    _c(
                                      "label",
                                      {
                                        staticClass:
                                          "checkbox-bootstrap checkbox-lg"
                                      },
                                      [
                                        _c("input", {
                                          directives: [
                                            {
                                              name: "model",
                                              rawName: "v-model",
                                              value: _vm.isAcceptDeclaration,
                                              expression: "isAcceptDeclaration"
                                            }
                                          ],
                                          attrs: { type: "checkbox" },
                                          domProps: {
                                            checked: Array.isArray(
                                              _vm.isAcceptDeclaration
                                            )
                                              ? _vm._i(
                                                  _vm.isAcceptDeclaration,
                                                  null
                                                ) > -1
                                              : _vm.isAcceptDeclaration
                                          },
                                          on: {
                                            change: function($event) {
                                              var $$a = _vm.isAcceptDeclaration,
                                                $$el = $event.target,
                                                $$c = $$el.checked
                                                  ? true
                                                  : false
                                              if (Array.isArray($$a)) {
                                                var $$v = null,
                                                  $$i = _vm._i($$a, $$v)
                                                if ($$el.checked) {
                                                  $$i < 0 &&
                                                    (_vm.isAcceptDeclaration = $$a.concat(
                                                      [$$v]
                                                    ))
                                                } else {
                                                  $$i > -1 &&
                                                    (_vm.isAcceptDeclaration = $$a
                                                      .slice(0, $$i)
                                                      .concat(
                                                        $$a.slice($$i + 1)
                                                      ))
                                                }
                                              } else {
                                                _vm.isAcceptDeclaration = $$c
                                              }
                                            }
                                          }
                                        }),
                                        _vm._v(" "),
                                        _c("span", {
                                          staticClass: "checkbox-placeholder",
                                          staticStyle: {
                                            "background-color": "white"
                                          }
                                        }),
                                        _vm._v(
                                          "\r\n                                " +
                                            _vm._s(_vm.DeclarationText) +
                                            " "
                                        ),
                                        _vm._m(3)
                                      ]
                                    )
                                  ]
                                )
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                staticClass:
                                  "col-md-12 form-group form-bottom-set"
                              },
                              [
                                _c(
                                  "label",
                                  {
                                    staticClass: "form-label",
                                    attrs: { for: "customerName" }
                                  },
                                  [_vm._v("Signature of Cardholder")]
                                ),
                                _vm._v(" "),
                                _c("div", { staticClass: "requiredstar" }, [
                                  _vm._v("*")
                                ]),
                                _vm._v(" "),
                                _c("input", {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value: _vm.customerSignedName,
                                      expression: "customerSignedName"
                                    }
                                  ],
                                  ref: "signature",
                                  staticClass: "form-control",
                                  attrs: {
                                    type: "text",
                                    placeholder:
                                      "Please Enter Cardholder Full Name",
                                    disabled: !_vm.disableSignature
                                  },
                                  domProps: { value: _vm.customerSignedName },
                                  on: {
                                    input: function($event) {
                                      if ($event.target.composing) {
                                        return
                                      }
                                      _vm.customerSignedName =
                                        $event.target.value
                                    }
                                  }
                                }),
                                _vm._v(" "),
                                _c("font", { staticClass: "text-danger" }, [
                                  _vm._v(_vm._s(_vm.customerSignedNameError))
                                ])
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _vm._m(4),
                            _vm._v(" "),
                            _vm.showSignDate
                              ? [
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "col-md-12 form-group form-bottom-set"
                                    },
                                    [
                                      _c(
                                        "label",
                                        {
                                          staticClass: "form-label",
                                          attrs: { for: "customerName" }
                                        },
                                        [_vm._v("Signature Date")]
                                      ),
                                      _vm._v(" "),
                                      _c("input", {
                                        staticClass: "form-control",
                                        attrs: {
                                          disabled: true,
                                          type: "text",
                                          id: "email3",
                                          placeholder:
                                            "Please Enter Cardholder Full Name"
                                        },
                                        domProps: { value: _vm.setMoment() }
                                      })
                                    ]
                                  )
                                ]
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.showCheckBox
                              ? _c(
                                  "div",
                                  {
                                    staticClass:
                                      "col-md-12 form-check form-group form-bottom-set",
                                    staticStyle: {
                                      "padding-left": "3rem",
                                      "padding-top": "1rem",
                                      "padding-bottom": "1rem"
                                    }
                                  },
                                  [
                                    _c(
                                      "label",
                                      {
                                        staticClass:
                                          "checkbox-bootstrap checkbox-lg"
                                      },
                                      [
                                        _c("input", {
                                          directives: [
                                            {
                                              name: "model",
                                              rawName: "v-model",
                                              value: _vm.isAddPassword,
                                              expression: "isAddPassword"
                                            }
                                          ],
                                          attrs: { type: "checkbox" },
                                          domProps: {
                                            checked: Array.isArray(
                                              _vm.isAddPassword
                                            )
                                              ? _vm._i(
                                                  _vm.isAddPassword,
                                                  null
                                                ) > -1
                                              : _vm.isAddPassword
                                          },
                                          on: {
                                            change: function($event) {
                                              var $$a = _vm.isAddPassword,
                                                $$el = $event.target,
                                                $$c = $$el.checked
                                                  ? true
                                                  : false
                                              if (Array.isArray($$a)) {
                                                var $$v = null,
                                                  $$i = _vm._i($$a, $$v)
                                                if ($$el.checked) {
                                                  $$i < 0 &&
                                                    (_vm.isAddPassword = $$a.concat(
                                                      [$$v]
                                                    ))
                                                } else {
                                                  $$i > -1 &&
                                                    (_vm.isAddPassword = $$a
                                                      .slice(0, $$i)
                                                      .concat(
                                                        $$a.slice($$i + 1)
                                                      ))
                                                }
                                              } else {
                                                _vm.isAddPassword = $$c
                                              }
                                            }
                                          }
                                        }),
                                        _vm._v(" "),
                                        _c("span", {
                                          staticClass: "checkbox-placeholder"
                                        }),
                                        _vm._v(
                                          "\r\n                                  Add Password\r\n                              "
                                        )
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _vm.isPassword === "checkbox"
                                      ? _c("input", {
                                          directives: [
                                            {
                                              name: "show",
                                              rawName: "v-show",
                                              value: _vm.isAddPassword,
                                              expression: "isAddPassword"
                                            },
                                            {
                                              name: "model",
                                              rawName: "v-model",
                                              value: _vm.password,
                                              expression: "password"
                                            }
                                          ],
                                          staticClass: "col-7",
                                          attrs: {
                                            placeholder: "Password",
                                            type: "checkbox"
                                          },
                                          domProps: {
                                            checked: Array.isArray(_vm.password)
                                              ? _vm._i(_vm.password, null) > -1
                                              : _vm.password
                                          },
                                          on: {
                                            change: function($event) {
                                              var $$a = _vm.password,
                                                $$el = $event.target,
                                                $$c = $$el.checked
                                                  ? true
                                                  : false
                                              if (Array.isArray($$a)) {
                                                var $$v = null,
                                                  $$i = _vm._i($$a, $$v)
                                                if ($$el.checked) {
                                                  $$i < 0 &&
                                                    (_vm.password = $$a.concat([
                                                      $$v
                                                    ]))
                                                } else {
                                                  $$i > -1 &&
                                                    (_vm.password = $$a
                                                      .slice(0, $$i)
                                                      .concat(
                                                        $$a.slice($$i + 1)
                                                      ))
                                                }
                                              } else {
                                                _vm.password = $$c
                                              }
                                            }
                                          }
                                        })
                                      : _vm.isPassword === "radio"
                                      ? _c("input", {
                                          directives: [
                                            {
                                              name: "show",
                                              rawName: "v-show",
                                              value: _vm.isAddPassword,
                                              expression: "isAddPassword"
                                            },
                                            {
                                              name: "model",
                                              rawName: "v-model",
                                              value: _vm.password,
                                              expression: "password"
                                            }
                                          ],
                                          staticClass: "col-7",
                                          attrs: {
                                            placeholder: "Password",
                                            type: "radio"
                                          },
                                          domProps: {
                                            checked: _vm._q(_vm.password, null)
                                          },
                                          on: {
                                            change: function($event) {
                                              _vm.password = null
                                            }
                                          }
                                        })
                                      : _c("input", {
                                          directives: [
                                            {
                                              name: "show",
                                              rawName: "v-show",
                                              value: _vm.isAddPassword,
                                              expression: "isAddPassword"
                                            },
                                            {
                                              name: "model",
                                              rawName: "v-model",
                                              value: _vm.password,
                                              expression: "password"
                                            }
                                          ],
                                          staticClass: "col-7",
                                          attrs: {
                                            placeholder: "Password",
                                            type: _vm.isPassword
                                          },
                                          domProps: { value: _vm.password },
                                          on: {
                                            input: function($event) {
                                              if ($event.target.composing) {
                                                return
                                              }
                                              _vm.password = $event.target.value
                                            }
                                          }
                                        }),
                                    _vm._v(" "),
                                    _c(
                                      "button",
                                      {
                                        directives: [
                                          {
                                            name: "show",
                                            rawName: "v-show",
                                            value: _vm.isAddPassword,
                                            expression: "isAddPassword"
                                          }
                                        ],
                                        on: {
                                          click: function($event) {
                                            $event.preventDefault()
                                            return _vm.showPassword(
                                              _vm.isShowPassword
                                            )
                                          }
                                        }
                                      },
                                      [
                                        _c("i", {
                                          directives: [
                                            {
                                              name: "show",
                                              rawName: "v-show",
                                              value: !_vm.isShowPassword,
                                              expression: "!isShowPassword"
                                            }
                                          ],
                                          staticClass: "fa fa-eye-slash",
                                          staticStyle: { padding: "6px" },
                                          attrs: { "aria-hidden": "true" }
                                        }),
                                        _vm._v(" "),
                                        _c("i", {
                                          directives: [
                                            {
                                              name: "show",
                                              rawName: "v-show",
                                              value: _vm.isShowPassword,
                                              expression: "isShowPassword"
                                            }
                                          ],
                                          staticClass: "fa fa-eye",
                                          staticStyle: { padding: "6px" },
                                          attrs: { "aria-hidden": "true" }
                                        })
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c("font", { staticClass: "text-danger" }, [
                                      _vm._v(_vm._s(_vm.setPasswordError))
                                    ])
                                  ],
                                  1
                                )
                              : _vm._e()
                          ],
                          2
                        )
                      ]
                    )
                  ]
                )
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "help is-danger" }, [
                _vm._v(_vm._s(_vm.error_msg_login))
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "text-right mt-4" }, [
                _c("input", {
                  staticClass: "btn btn-primary",
                  attrs: {
                    id: "addBenifitBtn",
                    type: "submit",
                    value: "Submit",
                    disabled: !_vm.isSave
                  },
                  on: {
                    click: function($event) {
                      $event.preventDefault()
                      return _vm.saveCustomerDetail()
                    }
                  }
                }),
                _vm._v(" "),
                _c("input", {
                  staticClass: "back_button btn btn-primary ml-2",
                  attrs: {
                    id: "CancelBenifit",
                    type: "submit",
                    value: "Cancel"
                  },
                  on: {
                    click: function($event) {
                      $event.preventDefault()
                      return _vm.cancelOrderDetailForm()
                    }
                  }
                })
              ])
            ])
          : _vm._e(),
        _vm._v(" "),
        _vm.isCancelConfirmed
          ? _c("div", { staticClass: "error-detail-main forms-container" }, [
              _c("div", { staticClass: "page-header-top-container" }),
              _vm._v(" "),
              _vm._m(5)
            ])
          : _vm._e()
      ]),
      _vm._v(" "),
      _c("app-footer")
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      { staticClass: "col-md-12 page-header-bottom-container" },
      [_c("h3", [_vm._v("Personal Information")])]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-md-2 form-group form-bottom-set" }, [
      _c("label", { staticClass: "form-label", attrs: { for: "city" } }, [
        _vm._v("Country")
      ]),
      _vm._v(" "),
      _c("input", {
        staticClass: "form-control",
        attrs: { type: "text", id: "country", value: "US", disabled: "" }
      })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      { staticClass: "col-md-12 page-header-bottom-container" },
      [_c("h3", [_vm._v("Card Details")])]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "a",
      {
        attrs: {
          href: "https://www.velocityvehiclegroup.com/privacy",
          target: "_blank"
        }
      },
      [_c("u", [_vm._v("VVG Group Terms and Condition & its Privacy Policy")])]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-md-12 form-group form-bottom-set" }, [
      _c(
        "label",
        { staticClass: "form-label", attrs: { for: "customerName" } },
        [
          _vm._v(
            "By typing your name above, you are signing this form electronically. You agree that your electronic signature is the legal equivalent of your manual signature on this form"
          )
        ]
      )
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "row" }, [
      _c(
        "div",
        { staticClass: "col-md-12 form-group", attrs: { id: "customerForm2" } },
        [
          _c("div", { staticClass: "row" }, [
            _c(
              "div",
              { staticClass: "col-md-12 page-header-bottom-container" },
              [
                _c("h3", { staticClass: "text-center" }, [
                  _vm._v(
                    "You have cancelled the submission, please close this window."
                  )
                ])
              ]
            )
          ])
        ]
      )
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-3e835ab0", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3e835ab0","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Order/CustomerCardDetail.vue
// module id = null
// module chunks = 